import React from 'react';
import { Typography } from 'antd';
import { MergedOrder } from '../../../types/process/order';
import { useStaffMap } from '../../../services/store/organization.store';
import { getOrderAuditDisplayName } from '../order.effect';
import { AuditStatusMap } from '../../../types/process/order-audit';

const { Text } = Typography;

export const OrderAuditInfo: React.FC<{ order: MergedOrder }> = ({ order }) => {
  const { staffMap } = useStaffMap();
  const auditorName = getOrderAuditDisplayName(order, staffMap);
  const operatorName = staffMap.get(order.order.preprocessOperatorId || 0)?.name || '-';
  
  // 如果处于审核阶段且有结论（非待审/非审核中），可以展示初审结论
  // 待审 = 0, 审核中 = 1， 挂起 = 2, 建议通过 = 3, 建议拒绝 = 4, 已释放 = 5, 审核中断 = 6
  // 根据要求，只展示是否通过（3, 4）以及审核中断（6）
  const hasAuditConclusion = [3, 4, 6].includes(order.order.auditStatus);

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 4 }}>
      <Text style={{ color: '#1677ff' }}>运营: {operatorName}</Text>
      <Text style={{ color: '#1677ff' }}>审核: {auditorName}</Text>
      {hasAuditConclusion && (
        <Text style={{ color: '#1677ff' }}>初审结论: {AuditStatusMap[order.order.auditStatus] || '-'}</Text>
      )}
    </div>
  );
};
